export { default } from "./app-checkbox.component";
export * from "./app-checkbox.types";
